export const TRACKING_PROFILES = {
  DESCRIPTION: 'This is a list of your unique URLs used for tracking affiliate performance and traffic.',
  INSTRUCTION: 'Please use the link to the webpage that contains the information regarding the merchant\'s products.',
};
